import { render, staticRenderFns } from "./TentCreate.vue?vue&type=template&id=3d88b70a&scoped=true"
import script from "./TentCreate.vue?vue&type=script&lang=ts"
export * from "./TentCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88b70a",
  null
  
)

export default component.exports